import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=fb1f4c1a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1f4c1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb1f4c1a')) {
      api.createRecord('fb1f4c1a', component.options)
    } else {
      api.reload('fb1f4c1a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=fb1f4c1a&scoped=true&", function () {
      api.rerender('fb1f4c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m4CNGn10TMOl/JS/comp/Accordion.vue"
export default component.exports